<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M6.25 4H13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.75 6.625H15.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.1515 9.25H4.84846C3.85649 9.25 3.13769 10.1957 3.40319 11.1515L4.44486 14.9015C4.6252 15.5507 5.21633 16 5.89013 16H14.1099C14.7837 16 15.3748 15.5507 15.5552 14.9015L16.5969 11.1515C16.8624 10.1957 16.1436 9.25 15.1515 9.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SpyderOverviewIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>